import { type RouteSectionProps } from "@solidjs/router";
import { type Component, createEffect, createMemo, createSignal, Show } from "solid-js";
import { useTranslation } from "../../state/i18n.tsx";
import { useAuthDispatch } from "../../state/auth.tsx";
import GlobalLoadingPage from "../GlobalLoadingPage.tsx";
import SignupService from "../../services/SignupService.ts";
import pMinDelay from "p-min-delay";
import { MINIMUM_PAGE_LOADING_DELAY } from "../../constants.ts";
import { ValidationFailed } from "./ValidationFailed.tsx";

const EmailValidationPage: Component<RouteSectionProps<never>> = (props) => {
  const { t } = useTranslation();
  const { login } = useAuthDispatch();
  const token = createMemo(() => props.params.token!);
  const validateEmailMutation = SignupService.validateEmail();
  const [validationFailed, setValidationFailed] = createSignal();

  createEffect(() => {
    pMinDelay(validateEmailMutation.mutateAsync({ token: token() }), MINIMUM_PAGE_LOADING_DELAY)
      // The validated account has no session yet, so the identity server would log in whoever is still signed in there
      .then(() => login(undefined, { forcePrompt: true }))
      .catch(() => setValidationFailed(true));
  });

  return (
    <Show when={validationFailed()} fallback={<GlobalLoadingPage text={t(($) => $.EMAIL_VALIDATION_VERIFYING)} />}>
      <ValidationFailed />
    </Show>
  );
};

export default EmailValidationPage;
